export default {
    state: {
        user: {
            loading: true,
            statusOk: true,
            data: null
        },
        review: {
            creating: false,
            statusOk: true,
            message: "",
        },
        post: {
            searchingCount: false,
            searchCount: 0,
            loadingPosts: false,
            statusOk: null,
            errMessage: "",
            okMessage: "",
            total: 100,
            itemsPerPage: 10,
            page: 0,
            items: []
        }
    },
    mutations: {
        'USER_LOADING' (state, val) {
            state.user.loading = val;
        },
        'USER_LOADING_SUCCESS' (state, val) {
            state.user.statusOk = true;
            if(val.reviews) val.reviews.forEach(item => {
                item.deleting = false;
                item.errMessage = "";
            });
            state.user.data = val;
        },
        'USER_LOADING_ERROR' (state) {
            state.user.statusOk = false;
        },
        'USER_REVIEW_CREATING' (state, val) {
            state.review.creating = val;
        },
        'USER_REVIEW_CREATING_SUCCESS' (state, val) {
            state.review.statusOk = true;
            state.user.data = val;
            state.review.message = "Review successfully submitted."
        },
        'USER_REVIEW_CREATING_ERROR' (state, val) {
            state.review.statusOk = false;
            state.review.message = val;
        },
        'USER_POST_FETCHING' (state, val) {
            state.post.loadingPosts = val;
        },
        'USER_POST_FETCHING_SUCCESS' (state, val) {
            state.post.statusOk = true;
            state.post.total = val.total;
            state.post.itemsPerPage = val.itemsPerPage;
            state.post.page = val.page;
            state.post.items = val.items;
            state.post.errMessage = "";
        },
        'USER_POST_FETCHING_ERROR' (state, val) {
            state.post.statusOk = false;
            state.post.errMessage = val;
            state.post.okMessage = "";
        },
        'USER_SEARCHING_COUNT' (state, val) {
            state.post.searchingCount = val;
        },
        'USER_SEARCH_COUNT' (state, val) {
            state.post.searchCount = val;
        },
        'USER_REVIEW_DELETING' (state, val) {
            if(state.user.data.reviews) for(let i=0; i<state.user.data.reviews.length; i++) {
                if(val._id === state.user.data.reviews[i]._id) {
                    state.user.data.reviews[i].deleting = val.deleting;
                }
            }
        },
        'USER_REVIEW_DELETING_ERROR' (state, val) {
            if(state.user.data.reviews) for(let i=0; i<state.user.data.reviews.length; i++) {
                if(val._id === state.user.data.reviews[i]._id) {
                    state.user.data.reviews[i].errMessage = val.errMessage;
                    break;
                }
            }
        },
        'USER_REVIEW_DELETING_SUCCESS' (state, val) {
            if(state.user.data.reviews) for(let i=0; i<state.user.data.reviews.length; i++) {
                if(val === state.user.data.reviews[i]._id) {
                    state.user.data.reviews.splice(i, 1);
                    break;
                }
            }
        }
    },
    actions: {
        'USER_FETCH' ({commit}, userID) {
            /* eslint-disable */
            commit('USER_LOADING', true);
            axios.get(`/user/${userID}`)
            .then(resp => {
                commit('USER_LOADING', false);
                commit('USER_LOADING_SUCCESS', resp.data.response);
                console.log("detail post", resp);
            })
            .catch(err => {
                /*
                commit('USER_LOADING', false);
                commit('USER_LOADING_ERROR');
                console.log("detial post err", err);
                */
               commit('USER_LOADING', false);
               commit('USER_LOADING_SUCCESS', {
                    _id: "randomID",
                    name: "Prataksha Gurung",
                    role: "store",
                    email: "g3prataksha@gmail.com",
                    phone: "+358 456059077",
                    country: "Finland",
                    province: "Uusimaa",
                    city: "Helsinki",
                    address: "Aleksanterinkatu 26 B 21",
                    website: "google.com",
                    imageURI: "https://lh3.googleusercontent.com/nkXcoT_H3KLXmcUraRJCQpHto_gkOrv6p0zEOYcHzoyerE2PeKqtgeCQX4Oo2FmYQG1D=s180-rw",
                    contacts: [
                        {name: "Daniel", phone: "+358 56780988", email: "daniel@gmail.com", languages: ["EN", "FI"]},
                        {name: "Daniel", phone: "+358 56780988", email: "daniel@gmail.com", languages: ["EN", "FI"]},
                        {name: "Daniel", phone: "+358 56780988", email: "daniel@gmail.com", languages: ["EN", "FI"]}
                    ],
                    reviews: [0,0,0]
               });
            });
        },
        'USER_POST_REVIEW' ({commit, rootState}, params) {
            /* eslint-disable */
            return new Promise(resolve => {
                console.log("params", params);
                commit('USER_REVIEW_CREATING', true);
                axios.post(`/user/${params.userID}/review`, params.payload)
                .then(resp => {
                    commit('USER_REVIEW_CREATING', false);
                    commit('USER_REVIEW_CREATING_SUCCESS', resp.data.response);
                    console.log("review post", resp);
                    resolve();
                })
                .catch(err => {
                    commit('USER_REVIEW_CREATING', false);
                    commit('USER_REVIEW_CREATING_ERROR', rootState.locale === "en" ? 'Error. Failed to submit review':'Error. Ei voitu lähettä palautetta');
                    console.log("review post err", err);
                });
            });
        },
        'UESER_REVIEW_DELETE' ({commit, rootState}, params) {
            commit('USER_REVIEW_DELETING', {_id: params.reviewID, deleting: true});
            axios.delete(`/user/${params.userID}/review/${params.reviewID}`)
            .then(resp => {
                commit('USER_REVIEW_DELETING', {_id: params.reviewID, deleting: false});
                commit('USER_REVIEW_DELETING_SUCCESS', params.reviewID);
                console.log("review post", resp);
            })
            .catch(err => {
                commit('USER_REVIEW_DELETING', {_id: params.reviewID, deleting: false});
                commit('USER_REVIEW_DELETING_ERROR', {_id: params.reviewID, errMessage: rootState.locale === "en" ? 'Error. Failed to delete the review':'Error. Palautetta ei voitu poistaa'});
                console.log("review post err", err);
            });
        },
        'USER_POST_FETCH' ({commit, rootState}, query) {
            commit('USER_POST_FETCHING', true);
            query.sort = "-currentPrice";
            axios.get(`/item`, {params: query})
            .then(resp => {
                commit('USER_POST_FETCHING', false);
                commit('USER_POST_FETCHING_SUCCESS', resp.data.response);
                console.log("user post", resp);
            })
            .catch(err => {
                commit('USER_POST_FETCHING', false);
                commit('USER_POST_FETCHING_ERROR', rootState.locale === "en" ? 'Error. Failed to fetch reviews':'Error. Palauteiden hakeminen epäonnistui');
                console.log("user post err", err);
            });
        },
        'USER_POST_FETCH_COUNT' ({commit}, query) {
            /* eslint-disable */
            console.log("count query", query);
            //query.status = "selling";
            query.searchType = "count";
            commit('USER_SEARCHING_COUNT', true);
            axios.get(`/item`, {
                params: query
            })
            .then(resp => {
                commit('USER_SEARCHING_COUNT', false);
                commit('USER_SEARCH_COUNT', resp.data.response.total);
                console.log("count posts", resp);
            })
            .catch(err => {
                commit('USER_SEARCHING_COUNT', false);
                commit('USER_SEARCH_COUNT', {total: 0});
                console.log("count posts err", err);
            });
        }
    }
};